import React from 'react'
import Application from './src/Navigators/Application'
import { Provider } from 'react-redux'
import { store } from './src/Store'

import './src/Translation/i18n'

export default function App() {
  return (
    <Provider store={store}>
      <Application />
    </Provider>
  )
}
